export default __webpack_public_path__ + "static/media/admomentum_logo.0a7f5434.png";